import React, { ReactElement } from 'react';

import { Flex, HStack } from '@chakra-ui/react';

export function PageCard({
    id,
    children,
    ...props
}: {
    id?: string;
    children: ReactElement | ReactElement[];
}): React.ReactElement {
    return (
        <Flex
            id={id}
            justify={'space-between'}
            direction={'column'}
            pt={{ base: 3, md: 6 }}
            px={{ base: 4, md: 8 }}
            shadow={'base'}
            bg='white'
            {...props}
        >
            {children}
        </Flex>
    );
}

export function PageCardFooter(props: {
    children: ReactElement | ReactElement[];
}): React.ReactElement {
    return (
        <HStack
            spacing='4'
            justify={'flex-end'}
            py='4'
            borderTop={1}
            borderColor='gray.200'
            borderStyle='solid'
        >
            {props.children}
        </HStack>
    );
}
